import AppProvider from 'contexts/app';
import AppBarProvider from 'contexts/appBar';
import { useAuth } from 'contexts/auth';
import DialogProvider from 'contexts/dialog';
import JoyrideProvider from 'contexts/joyride';
import NavigationGuardProvider from 'contexts/navigationGuard';
import StripeProvider from 'contexts/stripe';
import ViewportProvider from 'contexts/viewport';
import WebsocketProvider from 'contexts/websocket';

const ProviderWrapper = ({ children }) => {
    const { currentUser } = useAuth();
    return (
        <ViewportProvider>
            <AppBarProvider>
                <DialogProvider>
                    <NavigationGuardProvider>
                        <WebsocketProvider>
                            <AppProvider>
                                <JoyrideProvider>
                                    {currentUser?.has_full_access ? (
                                        children
                                    ) : (
                                        <StripeProvider>{children}</StripeProvider>
                                    )}
                                </JoyrideProvider>
                            </AppProvider>
                        </WebsocketProvider>
                    </NavigationGuardProvider>
                </DialogProvider>
            </AppBarProvider>
        </ViewportProvider>
    );
};

export default ProviderWrapper;
